const formatStructuredLine = (name: string | null | undefined, relationship: string | null | undefined) => {
  if (!name?.trim() && !relationship?.trim()) return "—";
  if (!relationship?.trim()) return name?.trim() ?? "—";
  if (!name?.trim()) return relationship.trim();
  return `${name.trim()} (${relationship.trim()})`;
};

export function formatCcmsBeneficiaryLine(
  raw: string | null | undefined,
  name: string | null | undefined,
  relationship: string | null | undefined
): string {
  const trimmedRaw = raw?.trim();
  if (trimmedRaw) return trimmedRaw;
  return formatStructuredLine(name, relationship);
}

export function formatCcmsBeneficiaryLineForCell(
  raw: string | null | undefined,
  name: string | null | undefined,
  relationship: string | null | undefined
): string | null {
  const formatted = formatCcmsBeneficiaryLine(raw, name, relationship);
  return formatted === "—" ? null : formatted;
}
